import { Show } from "solid-js";
import styles from "./SearchInput.module.css";

interface SearchInputProps {
  value: string;
  onInput: (next: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  autofocus?: boolean;
}

export function SearchInput(props: SearchInputProps) {
  let inputRef: HTMLInputElement | undefined;

  function clear() {
    props.onInput("");
    inputRef?.focus();
  }

  function onKey(e: KeyboardEvent) {
    if (e.key === "Escape" && props.value) {
      e.preventDefault();
      clear();
    }
  }

  return (
    <div class={styles.wrap}>
      <i class={`fa-solid fa-magnifying-glass ${styles.icon}`} aria-hidden="true" />
      <input
        ref={inputRef}
        type="text"
        class={styles.input}
        placeholder={props.placeholder ?? "Search..."}
        aria-label={props.ariaLabel ?? "Search"}
        value={props.value}
        onInput={(e) => props.onInput(e.currentTarget.value)}
        onKeyDown={onKey}
        // @ts-ignore
        autofocus={props.autofocus}
      />
      <Show when={props.value}>
        <button class={styles.clear} onClick={clear} aria-label="Clear search">
          <i class="fa-solid fa-xmark" />
        </button>
      </Show>
    </div>
  );
}
